/**
 * Modal Management Utilities
 * Handles modal show/hide and event listener management
 */

export class ModalManager {
  static show(modal) {
    if (!modal) return;
    // Ensure modal is properly positioned and centered
    modal.style.position = 'fixed';
    modal.style.top = '0';
    modal.style.left = '0';
    modal.style.right = '0';
    modal.style.bottom = '0';
    modal.style.display = 'flex';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    modal.classList.remove('hidden');
    
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }

  static hide(modal) {
    if (!modal) return;
    modal.classList.add('hidden');
    modal.style.display = 'none';
    
    // Restore body scroll when modal is closed
    document.body.style.overflow = '';
  }

  static toggle(modal) {
    if (modal?.classList.contains('hidden')) {
      this.show(modal);
    } else {
      this.hide(modal);
    }
  }

  static setupCloseHandlers(modal, options = {}) {
    const {
      closeButtonSelector = '[data-modal-close]',
      cancelButtonSelector = '[data-modal-cancel]',
      overlaySelector = '.modal-overlay',
      onClose = null
    } = options;

    const closeHandler = () => {
      this.hide(modal);
      if (onClose) onClose();
    };

    // Close button
    const closeBtn = modal.querySelector(closeButtonSelector);
    if (closeBtn && !closeBtn.dataset.listenerAttached) {
      closeBtn.dataset.listenerAttached = 'true';
      closeBtn.addEventListener('click', closeHandler);
    }

    // Cancel button
    const cancelBtn = modal.querySelector(cancelButtonSelector);
    if (cancelBtn && !cancelBtn.dataset.listenerAttached) {
      cancelBtn.dataset.listenerAttached = 'true';
      cancelBtn.addEventListener('click', closeHandler);
    }

    // Overlay click
    const overlay = modal.querySelector(overlaySelector);
    if (overlay && !overlay.dataset.listenerAttached) {
      overlay.dataset.listenerAttached = 'true';
      overlay.addEventListener('click', closeHandler);
    }

    // Escape key (only add once globally)
    if (!document.hasModalEscapeListener) {
      document.hasModalEscapeListener = true;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal && !modal.classList.contains('hidden')) {
          closeHandler();
        }
      });
    }

    return closeHandler;
  }
}

